import { Box } from '@chakra-ui/react';

import './audioLoader.css';

export const ChatMessageAudioLoader = () => (
  <Box className="loader" data-testid="audio-loader" />
);
